import script from "./PartialReturnGeneralBill.vue?vue&type=script&setup=true&lang=js"
export * from "./PartialReturnGeneralBill.vue?vue&type=script&setup=true&lang=js"

import "./PartialReturnGeneralBill.vue?vue&type=style&index=0&id=bf99c196&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf99c196"]])

export default __exports__